// removed by extract-text-webpack-plugin
module.exports = {"chip":"theme__chip___3Iv9P","avatar":"theme__avatar___2o8mD","deletable":"theme__deletable___2hlBs","delete":"theme__delete___3nnfj","deleteIcon":"theme__deleteIcon___2sopz","deleteX":"theme__deleteX___10NaZ"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/chip/theme.css
// module id = 739
// module chunks = 0